import { VueModule } from '@Foundation/utilities';
import SustainabilityModule from './code/Scripts/components/sustainability-module.vue';

export default VueModule({
    components: {
        SustainabilityModule
    }
});